var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web"},[_c('div',{staticClass:"Empty"},[_c('div',{staticClass:"EmptyImage"},[_c('img',{attrs:{"src":require("../../../assets/images/frozen.png"),"alt":""}})]),_c('p',{staticClass:"text"},[_vm._v("您的账户已被冻结...")])])])
}]

export { render, staticRenderFns }